module.exports = __webpack_public_path__ + "img/02.5b95afb7.png";